import { createBrowserRouter } from 'react-router-dom'
import { Login } from '@/pages/auth/Login'
import { Dashboard } from '@/pages/Dashboard'
import { Profile } from '@/pages/Profile'
import { UserList } from '@/pages/users/UserList'
import { UserCreate } from '@/pages/users/UserCreate'
import { UserEdit } from '@/pages/users/UserEdit'
import { UserDetail } from '@/pages/users/UserDetail'
import { HospitalList } from '@/pages/hospitals/HospitalList'
import { HospitalDetail } from '@/pages/hospitals/HospitalDetail'
import { HospitalImportsHistory } from '@/pages/hospitals/HospitalImportsHistory'
import { FeatureList } from '@/pages/features/FeatureList'
import { FeatureCreate } from '@/pages/features/FeatureCreate'
import { FeatureDetail } from '@/pages/features/FeatureDetail'
import { FeatureEdit } from '@/pages/features/FeatureEdit'
import { PermissionDashboard } from '@/pages/permissions/PermissionDashboard'
import { UserPermissions } from '@/pages/permissions/UserPermissions'
import { HospitalPermissions } from '@/pages/permissions/HospitalPermissions'
import { BulkPermissions } from '@/pages/permissions/BulkPermissions'
import { ApprovalQueue } from '@/pages/admin/ApprovalQueue'
import { ApprovalHistory } from '@/pages/admin/ApprovalHistory'
import { NotificationCenter } from '@/pages/admin/NotificationCenter'
import { AuditDashboard } from '@/pages/admin/AuditDashboard'
import { FeatureDefinitions } from '@/pages/admin/FeatureDefinitions'
import { AdminUserList } from '@/pages/admin/users/AdminUserList'
import { AdminUserCreate } from '@/pages/admin/users/AdminUserCreate'
import { AdminUserEdit } from '@/pages/admin/users/AdminUserEdit'
import { AdminUserDetail } from '@/pages/admin/users/AdminUserDetail'
import { NotFound } from '@/pages/NotFound'
import { AppLayout } from '@/components/layout/AppLayout'
import { ProtectedRoute } from './ProtectedRoute'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'profile',
        element: <Profile />,
      },
      {
        path: 'users',
        children: [
          {
            index: true,
            element: <UserList />,
          },
          {
            path: 'create',
            element: <UserCreate />,
          },
          {
            path: ':id',
            element: <UserDetail />,
          },
          {
            path: ':id/edit',
            element: <UserEdit />,
          },
        ],
      },
      {
        path: 'hospitals',
        children: [
          {
            index: true,
            element: <HospitalList />,
          },
          {
            path: 'imports',
            element: <HospitalImportsHistory />,
          },
          {
            path: ':id',
            element: <HospitalDetail />,
          },
        ],
      },
      {
        path: 'features',
        children: [
          {
            index: true,
            element: <FeatureList />,
          },
          {
            path: 'create',
            element: <FeatureCreate />,
          },
          {
            path: ':id',
            element: <FeatureDetail />,
          },
          {
            path: ':id/edit',
            element: <FeatureEdit />,
          },
        ],
      },
      {
        path: 'permissions',
        children: [
          {
            index: true,
            element: <PermissionDashboard />,
          },
          {
            path: 'users',
            element: <UserPermissions />,
          },
          {
            path: 'hospitals',
            element: <HospitalPermissions />,
          },
          {
            path: 'bulk',
            element: <BulkPermissions />,
          },
        ],
      },
      {
        path: 'admin',
        children: [
          {
            path: 'approvals',
            element: <ApprovalQueue />,
          },
          {
            path: 'approval-history',
            element: <ApprovalHistory />,
          },
          {
            path: 'notifications',
            element: <NotificationCenter />,
          },
          {
            path: 'audit',
            element: <AuditDashboard />,
          },
          {
            path: 'feature-definitions',
            element: <FeatureDefinitions />,
          },
          {
            path: 'users',
            children: [
              {
                index: true,
                element: <AdminUserList />,
              },
              {
                path: 'create',
                element: <AdminUserCreate />,
              },
              {
                path: ':email',
                element: <AdminUserDetail />,
              },
              {
                path: ':email/edit',
                element: <AdminUserEdit />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
])
